export default __webpack_public_path__ + "static/banner-PT-mov-578c7332bae79bf8a55bfe44c6e0fc64.png";